export default __webpack_public_path__ + "static/arnab-barua-1c19b54a15790b8cd8b6526b96b06596.jpg";